// Types
import type { Ref } from 'vue';
import type { TAutomatedEmailSentListQuery } from '~/modules/opportunities/automated-email/types';

import type {
  TAutomatedEmailSentModeFilter,
  TAutomatedEmailSentTriggerFilter,
} from '~/modules/opportunities/automated-email/sent/composables/use-sent-filters/types';

// Composables
import { useAutomatedEmailPatch } from '~/modules/opportunities/automated-email/composables/use-automated-email-patch';

export const useAutomatedEmailSentFilters = () => {
  const { patchId, saleType } = useAutomatedEmailPatch();

  const filterTriggerName: Ref<TAutomatedEmailSentTriggerFilter | null> = ref<
    TAutomatedEmailSentTriggerFilter | null
  >(null);

  const filterContactName: Ref<string> = ref<string>('');

  const filterMode: Ref<TAutomatedEmailSentModeFilter | null> =
    ref<TAutomatedEmailSentModeFilter | null>(null);

  const filterSentAtFrom: Ref<string> = ref<string>('');
  const filterSentAtTo: Ref<string> = ref<string>('');

  const setFilterTriggerName = (value: TAutomatedEmailSentTriggerFilter | null): void => {
    filterTriggerName.value = value;
  };

  const setFilterContactName = (value: string): void => {
    filterContactName.value = value;
  };

  const setFilterMode = (value: TAutomatedEmailSentModeFilter | null): void => {
    filterMode.value = value;
  };

  const setFilterSentAtFrom = (value: string): void => {
    filterSentAtFrom.value = value;
  };

  const setFilterSentAtTo = (value: string): void => {
    filterSentAtTo.value = value;
  };

  const toQueryParams = (page: number): TAutomatedEmailSentListQuery | null => {
    if (patchId.value === undefined) {
      return null;
    }

    const query: TAutomatedEmailSentListQuery = {
      page,
      patch_id: patchId.value,
      sale_type: saleType.value,
    };

    if (filterTriggerName.value !== null) {
      query['filter[trigger_name]'] = filterTriggerName.value;
    }

    const contactQ: string = filterContactName.value.trim();

    if (contactQ !== '') {
      query['filter[contact_name]'] = contactQ;
    }

    if (filterMode.value !== null) {
      query['filter[mode]'] = filterMode.value;
    }

    if (filterSentAtFrom.value !== '') {
      query['filter[sent_at_from]'] = filterSentAtFrom.value;
    }

    if (filterSentAtTo.value !== '') {
      query['filter[sent_at_to]'] = filterSentAtTo.value;
    }

    return query;
  };

  return {
    patchId,
    saleType,
    filterTriggerName,
    filterContactName,
    filterMode,
    filterSentAtFrom,
    filterSentAtTo,
    setFilterTriggerName,
    setFilterContactName,
    setFilterMode,
    setFilterSentAtFrom,
    setFilterSentAtTo,
    toQueryParams,
  };
};
